<template>
    <b-container fluid v-if="quickbooksSettings">
        <b-row class="mt-2">
            <b-col class="d-flex align-items-center">
                <form-select
                    :options="invoiceDateOptions"
                    v-model="quickbooksSettings.set_invoice_date_to"
                    floatingLabel="Set invoice date to"
                    class="quickbooks-settings-select"
                    @change="handleChangeSettings"
                />
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col class="d-flex align-items-center">
                <form-select
                    :options="invoiceClassOptions"
                    v-model="quickbooksSettings.one_class_per_line_detail"
                    floatingLabel="Invoice Class Assignment"
                    class="quickbooks-settings-select"
                    @change="handleChangeSettings"
                />
            </b-col>
        </b-row>        
    </b-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { formatResponseError } from '../../utils/api';
import BusyModal from '../generic/busy-modal/busy-modal.vue';
import FormSelect from '../generic/form-select/form-select.vue';
import API from '../../api';
import { QUICKBOOKS_ENDPOINT } from '../../endpoints';
export default {
    name: 'Settings',
    components: {
        BusyModal,
        FormSelect,
    },
    data() {
        return {
            quickbooksSettings: null,
        };
    },
    computed: {
        ...mapGetters('quickbooks', []),
        invoiceDateOptions() {
            return [
                {
                    value: 'CREATED',
                    text: 'Created Date',
                },
                {
                    value: 'CHECKIN',
                    text: 'Check-in Date',
                },
            ];
        },
        invoiceClassOptions() {
            return [
                {
                    value: false,
                    text: 'One to entire transaction',
                },
                {
                    value: true,
                    text: 'One to each row in transaction',
                },
            ];
        },
    },
    mounted() {
        this.fetchQuickBooksSettings();
    },
    methods: {
        async handleChangeSettings() {
            try {
                await API.post(`${QUICKBOOKS_ENDPOINT()}save-settings/`, this.quickbooksSettings);
                this.$store.commit(
                    'quickbooks/setOneClassPerLineDetail',
                    this.quickbooksSettings.one_class_per_line_detail
                );
                this.successToast({ text: 'QuickBooks settings successfuly updated.' });
            } catch (e) {
                console.log(e);
                this.errorToast({ text: 'Could not update QuickBooks settings' });
            }
        },
        async fetchQuickBooksSettings() {
            this.$parent.$emit('busy', true);
            try {
                const responseData = await API.get(`${QUICKBOOKS_ENDPOINT()}load-settings/`);
                this.quickbooksSettings = responseData.data;
            } catch (error) {
                console.log(error);
                const { generic } = formatResponseError(error);
                this.errorToast({
                    text: generic || `Could not get quickbooks settings.`,
                });
                return;
            } finally {
                this.$parent.$emit('busy', false);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
:deep(.quickbooks-settings-select) {
    width: 400px;
}
</style>
